// =============================================================================
// tareResolver — central resolver for "what tare should I apply for this
// container?".
//
// Inputs come from two places:
//   * container_type — the fixed enum (KF49_BIN, CHEP_BIN, RED_ARM_LUG,
//     GREY_ARM_LUG, STEEL_CAGE) picked via ContainerTypePicker.
//   * bin_type_id   — optional FK to a custom bin_types row (grower-
//     specific or system-default mirror; mig 285).
//
// Resolution order:
//   1. If bin_type_id is set, use that row's tare_kg directly.
//   2. Otherwise, look for the system-default row whose code equals
//      container_type. That row's tare_kg is the admin-edited default
//      for the enum value.
//   3. Otherwise, return null (caller decides what fallback to apply —
//      Rebin falls back to system_config.bin_tare_kg legacy global).
// =============================================================================

import type { ContainerType } from '@/lib/containerTypes'
import type { BinTypeRow } from '@/hooks/useBinTypes'

export function resolveTareKg(args: {
  containerType: ContainerType | null
  binTypeId:     string | null
  binTypes:      BinTypeRow[]
}): number | null {
  const { containerType, binTypeId, binTypes } = args
  if (binTypeId) {
    const row = binTypes.find(t => t.bin_type_id === binTypeId)
    if (row) return Number(row.tare_kg) || 0
  }
  if (containerType) {
    const row = binTypes.find(t => t.is_system_default && t.code === containerType)
    if (row) return Number(row.tare_kg) || 0
  }
  return null
}
